import clsx from 'clsx'
import { HeartIcon } from 'src/assets/svgIcons/HeartIcon';
import { HeartIconUnliked } from 'src/assets/svgIcons/HeartIconUnliked';
type WidgetMode = 'light' | 'dark'

interface IdeaOfTheMonthLikeButtonProps {
  liked: boolean
  mode?: WidgetMode
  disabled?: boolean
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const IdeaOfTheMonthLikeButton = ({
  liked,
  mode = 'light',
  disabled = false,
  onClick,
}: IdeaOfTheMonthLikeButtonProps) => {
  return (
    <button
      type="button"
      aria-label={liked ? 'Unlike idea' : 'Like idea'}
      aria-pressed={liked}
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        'inline-flex h-10 w-10 items-center justify-center rounded-full border',
        mode === 'dark'
          ? 'rounded-[100px] border-2 border-white bg-black text-white hover:bg-[#6E6E6E] focus-visible:bg-[#505050] '
          : 'rounded-[100px] border-2 border-black bg-white text-neutral-100 hover:bg-[#D4D4D4] focus-visible:bg-[#BDBDBD]',
        liked && 'bg-[rgba(247, 0, 0, 1)] text-white border-black',
        disabled && 'cursor-not-allowed opacity-70',
      )}
    >
      {liked ? <HeartIcon/> : <HeartIconUnliked mode={mode}  />}
    </button>
  )
}

export default IdeaOfTheMonthLikeButton
